import { useContext } from 'react';

import { CheckoutContext, ICheckoutContext } from '@contexts';

export const useCheckout = (): ICheckoutContext => {
  return useContext(CheckoutContext);
};
